function u(e, r, t, i, n) {
  return i && n || r ? "" : !e || !e.available ? "--" : t ? `$${e.salePrice}` : typeof e.price == "string" ? e.price : `$${e.price}`;
}
function f(e, r, t) {
  return r || !e ? !1 : t ? typeof e.price == "string" ? e.price : `$${e.price}` : !1;
}
function s(e) {
  switch (e) {
    case "xLarge":
      return "70px";
    case "medium":
    case "max":
    case "maxPlus":
      return "74px";
    default:
      return "54px";
  }
}
function g() {
  return new Date((/* @__PURE__ */ new Date()).getFullYear(), (/* @__PURE__ */ new Date()).getMonth(), (/* @__PURE__ */ new Date()).getDate()).getTime();
}
export {
  s as getCellHeight,
  u as getPriceText,
  f as getStrikePriceText,
  g as getTodaysDateTimeAtStart
};
